export const RSVP_STATUS_META = {
  attending: {
    label: "Attending",
    className: "bg-emerald-50 text-emerald-700",
  },
  accepted: {
    label: "Attending",
    className: "bg-emerald-50 text-emerald-700",
  },
  yes: {
    label: "Attending",
    className: "bg-emerald-50 text-emerald-700",
  },
  not_attending: {
    label: "Not attending",
    className: "bg-rose-50 text-rose-600",
  },
  declined: {
    label: "Not attending",
    className: "bg-rose-50 text-rose-600",
  },
  no: {
    label: "Not attending",
    className: "bg-rose-50 text-rose-600",
  },
  pending: {
    label: "Pending",
    className: "bg-gray-100 text-gray-500",
  },
};

export const normalizeStatus = (status) => String(status || "pending").trim().toLowerCase();

export const getRsvpMeta = (status) =>
  RSVP_STATUS_META[normalizeStatus(status)] || {
    label: String(status || "Pending"),
    className: "bg-gray-100 text-gray-500",
  };

export const hasResponseDetails = (guest) =>
  normalizeStatus(guest?.rsvp_status) !== "pending" ||
  Boolean(guest?.rsvp_message) ||
  Boolean(guest?.rsvp_allergies);

export const isAttendingStatus = (status) =>
  ["attending", "accepted", "yes"].includes(normalizeStatus(status));

export const getGuestDisplayName = (guest) => guest?.guest?.guest_name || "Guest";
